import script from "./XiaoguoSquare.vue?vue&type=script&setup=true&lang=js"
export * from "./XiaoguoSquare.vue?vue&type=script&setup=true&lang=js"

import "./XiaoguoSquare.vue?vue&type=style&index=0&id=4a26c592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a26c592"]])

export default __exports__